export const SKD_READINESS_STORAGE_KEY = "skd-readiness-progress";
export const INTERVIEW_READINESS_STORAGE_KEY = "interview-readiness-progress";
export const LOVE_LANGUAGE_STORAGE_KEY = "tes-love-language-progress";
export const KEPRIBADIAN_STORAGE_KEY = "tes-kepribadian-progress";
export const CV_BUILDER_STORAGE_KEY = "cv-builder-draft";
/** Identitas tamu untuk kuota CV Builder. Jika ikut terhapus, tamu mendapat kuota gratis baru. */
export const CV_BUILDER_GUEST_ID_KEY = "cv-builder-guest-id";

/**
 * Setelah logout/clear, sebelumunload di halaman tool bisa menulis ulang progress.
 * Flag ini memblokir save sampai full page reload (modul di-init ulang).
 */
let toolProgressPersistBlocked = false;

export function isToolProgressPersistBlocked(): boolean {
	return toolProgressPersistBlocked;
}

/** Blokir save progress tools (logout / hapus akun). Reset otomatis saat full page reload. */
export function blockToolProgressPersist(): void {
	toolProgressPersistBlocked = true;
}

/** Hanya untuk tes: izinkan save lagi tanpa reload. */
export function allowToolProgressPersist(): void {
	toolProgressPersistBlocked = false;
}

export function clearLocalStorageKeepGuestId(): void {
	blockToolProgressPersist();
	const guestId = localStorage.getItem(CV_BUILDER_GUEST_ID_KEY);
	localStorage.clear();
	if (guestId !== null) localStorage.setItem(CV_BUILDER_GUEST_ID_KEY, guestId);
}
